import React, { useState } from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import { mainTable } from "../css/Common"; 
import TextArea from "../ReusableComponents/TextArea"; // Make sure this exists and is correctly implemented
import { issueView} from "../components/HeaderAttribute";
import GridPage from "../components/GridPage";
const IssuesPopup = ({ data, data1 }) => {
    
   console.log("🔍 IssuesPopup data:", data);
  console.log("🔍 IssuesPopup data1:", data1);
    const cancel = () => {};

 
  return (
    <div class="w-full p-5">
      <div class=" border-black  "></div>
      <GridPage
        title={`Issues > ${data.IssueNo} > ${data.FormattedDate}`}
        header={issueView}
        records={data1}
        addView={true}
        tableHeight="h-60 overflow-y-auto"
      />
    </div>
  );
};

export default IssuesPopup;
